export function formatBytes(bytes?: number | null): string {
  if (bytes === null || bytes === undefined) return 'Unknown';
  if (bytes === 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / Math.pow(1024, exponent);
  return `${value.toFixed(value >= 100 || exponent === 0 ? 0 : 1)} ${units[exponent]}`;
}

export function formatCount(value?: number | null): string {
  if (value === null || value === undefined) return 'Unknown';
  return value.toLocaleString();
}

export function formatDate(value?: string | null): string {
  if (!value) return 'Never';
  return new Date(value).toLocaleDateString();
}

export function formatDateTime(value?: string | null): string {
  if (!value) return '-';
  return new Date(value).toLocaleString();
}

/** Renders uncollected values as Unknown rather than implying a false negative. */
export function formatNullableBool(value?: boolean | null): string {
  if (value === null || value === undefined) return 'Unknown';
  return value ? 'Yes' : 'No';
}

export function formatNullableNumber(value?: number | null): string {
  if (value === null || value === undefined) return 'Unknown';
  return value.toLocaleString();
}
